import hugenottenrathaus from "../assets/models/hugenottenrathaus.glb";
import ioshugenottenrathaus from "../assets/models/hugenottenrathaus.usdz";
import hugenottenrathausV0 from "../assets/models/hugenottenrathausv0.glb";
import ioshugenottenrathausV0 from "../assets/models/hugenottenrathausv0.usdz";
import hugenottenrathausShadow from "../assets/models/hugenottenrathausgshadow.glb";
import ioshugenottenrathausShadow from "../assets/models/hugenottenrathausgshadow.usdz";
const productItems = [
  {
    id: 1,
    name: "Hugenottenrathaus",
    modelSrc: hugenottenrathaus,
    iOSSrc: ioshugenottenrathaus,
    category: "Architecture",
    color: "Orange",
    annotations: [
      {
        title: "Clock",
        slot: "hotspot-1",
        position: "0m 10.5744572599492905m -0m",
        normal: "0.028332494851243895m 0.2137467602998606m 0.9764781575625839m",
        orbit: "0.0deg 0.0deg 12m",
        target: "-0.1053838m 0.01610652m 0.1076345m"
      }, {
        title: "Rathaus",
        slot: "hotspot-2",
        position: "0.0m 0.0m 0.0m",
        normal: "0.0m 0.0m 0.0m",
        orbit: "0.0deg 0.0deg 0.0m",
        target: "-10.0m 0.0m 0.0m"
      },
    ]
  }  
,
  {
    id: 2,
    name: "Hugenottenrathaus shadow",
    modelSrc: hugenottenrathausShadow,
    iOSSrc: ioshugenottenrathausShadow,
    category: "Architecture",
    color: "Orange",
    annotations: [
      {
        title: "Clock",
        slot: "hotspot-1",
        position: "0m 10.5744572599492905m -0m",
        normal: "0.028332494851243895m 0.2137467602998606m 0.9764781575625839m",
        orbit: "0.0deg 0.0deg 12m",
        target: "-0.1053838m 0.01610652m 0.1076345m"
      }, {
        title: "Rathaus",
        slot: "hotspot-2",
        position: "0.0m 0.0m 0.0m",
        normal: "0.0m 0.0m 0.0m",
        orbit: "0.0deg 0.0deg 0.0m",
        target: "-10.0m 0.0m 0.0m"
      },
    ]
  } 
];
export default productItems;
